<template>
  <mp-box>
    <mp-text
      v-if="data.submenuTitle"
      text-transform="uppercase"
      white-space="nowrap"
      font-size="sm"
      font-weight="semibold"
      letter-spacing="2px"
      color="blue.400"
      padding="2"
    >
      {{ data.submenuTitle }}
    </mp-text>
    <template v-for="submenu in data.submenu">
      <template v-if="!submenu.isHidden">
        <mp-accordion
          v-if="submenu.children && submenu.children.length"
          :key="submenu.name"
          :data-qa="`component-sidebar-child-content-submenu-${submenu.name.toLowerCase().replace(/\s+/g, '-')}`"
          :set="(activeParent = $route.path.includes(submenu.link))"
          allow-toggle
        >
          <mp-accordion-item border-bottom-width="0px!important">
            <mp-accordion-header
              gap="1"
              padding="2"
              border-radius="md"
              :background-color="activeParent ? 'blue.100' : 'transparent'"
              transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
              justify-content="space-between"
              :_hover="{
                color: 'blue.400',
                backgroundColor: activeParent ? 'blue.100' : 'blue.100',
                cursor: 'pointer',
              }"
              :data-qa="submenu.dataQA"
            >
              <mp-box>
                <mp-flex direction="column">
                  <mp-pseudo-box flex="1" border-radius="sm">
                    <mp-stack direction="row" align="center">
                      <mp-text white-space="nowrap" :color="activeParent ? 'blue.400' : 'dark'" :font-weight="activeParent ? 'semibold' : 'regular'">
                        {{ submenu.name }}
                      </mp-text>
                    </mp-stack>
                  </mp-pseudo-box>
                </mp-flex>
              </mp-box>
              <mp-accordion-icon />
            </mp-accordion-header>
            <mp-accordion-panel padding-y="0">
              <mp-box
                v-for="child in submenu.children"
                :key="child.name"
                :data-qa="`component-sidebar-child-content-child-${child.name.toLowerCase().replace(/\s+/g, '-')}`"
              >
                <mp-button
                  v-if="submenu.isDisabled"
                  v-mp-tooltip="{
                    label: 'Not available',
                    position: 'bottom',
                  }"
                  padding="2"
                  padding-left="4"
                  :is-disabled="submenu.isDisabled"
                  variant="link"
                  >{{ child.name }}</mp-button
                >
                <router-link v-else-if="!child.isHidden" v-slot="{ href, navigate, isActive }" :to="child.link">
                  <a :href="href" class="text-decoration-none" :data-qa="child.dataQA" @click="navigate">
                    <mp-flex direction="column">
                      <mp-pseudo-box
                        flex="1"
                        role="group"
                        border-radius="md"
                        padding-left="4"
                        padding-y="2"
                        :color="isActive ? 'dark' : 'gray.600'"
                        font-weight="regular"
                        transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                        :_hover="{
                          color: 'blue.400',
                          cursor: 'pointer',
                        }"
                      >
                        <mp-stack direction="row" align="center">
                          <mp-text :font-weight="isActive ? 'semibold' : 'inherit'" white-space="nowrap" color="inherit">
                            {{ child.name }}
                          </mp-text>
                        </mp-stack>
                      </mp-pseudo-box>
                    </mp-flex>
                  </a>
                </router-link>
              </mp-box>
            </mp-accordion-panel>
          </mp-accordion-item>
        </mp-accordion>

        <mp-box v-else :key="submenu.name">
          <mp-button
            v-if="submenu.isDisabled"
            v-mp-tooltip="{
              label: 'Not available',
              position: 'bottom',
            }"
            padding="2"
            :is-disabled="submenu.isDisabled"
            variant="link"
            >{{ submenu.name }}</mp-button
          >
          <router-link v-else v-slot="{ href, navigate, isActive }" :to="submenu.link">
            <a :href="href" class="text-decoration-none" :data-qa="submenu.dataQA" @click="navigate">
              <mp-flex direction="column">
                <mp-pseudo-box
                  flex="1"
                  role="group"
                  border-radius="md"
                  padding="2"
                  font-weight="regular"
                  transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
                  :background-color="isActive ? 'blue.100' : 'inherit'"
                  :color="isActive ? 'blue.400' : 'dark'"
                  :_hover="{
                    color: 'blue.400',
                    cursor: 'pointer',
                  }"
                >
                  <mp-stack direction="row" align="center">
                    <mp-text :font-weight="isActive ? 'semibold' : 'inherit'" white-space="nowrap" color="inherit">
                      {{ submenu.name }}
                    </mp-text>
                    <mp-badge v-if="submenu.badge" display="block" variant-color="red" text-align="center" line-height="14px" ml="auto">{{
                      submenu.badge
                    }}</mp-badge>
                  </mp-stack>
                </mp-pseudo-box>
              </mp-flex>
            </a>
          </router-link>
        </mp-box>
      </template>
    </template>
  </mp-box>
</template>

<script>
export default {
  name: 'SidebarChildContent',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
